import { endOfMonth, format, subMonths } from 'date-fns';

export type DashboardDatePeriod = 'this-month' | 'last-month';

export const DASHBOARD_DATE_PERIOD_OPTIONS: { key: DashboardDatePeriod; label: string }[] = [
  { key: 'this-month', label: 'This month' },
  { key: 'last-month', label: 'Last month' },
];

export const toDashboardDateParam = (period: DashboardDatePeriod): string => {
  const now = new Date();
  if (period === 'last-month') {
    return format(endOfMonth(subMonths(now, 1)), 'yyyy-MM-dd');
  }
  return format(now, 'yyyy-MM-dd');
};
